function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_b)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 306,
  height: 140,
  fill: "white",
  fillOpacity: 0.9
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M187.087 68.6267C186.687 69.7166 185.772 70.3754 184.617 70.3754C183.355 70.3754 181.996 69.3736 181.996 67.757C181.996 66.2633 183.249 65.1738 184.608 65.1738C185.229 65.1738 186.58 65.4548 187.087 66.9573H185.754C185.611 66.7116 185.336 66.2457 184.608 66.2457C183.888 66.2457 183.177 66.7728 183.177 67.7746C183.177 68.6095 183.773 69.3035 184.661 69.3035C185.052 69.3035 185.443 69.119 185.754 68.6267H187.087Z",
  fill: "black"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M187.931 67.7834C187.931 66.3073 189.148 65.1738 190.561 65.1738C191.956 65.1738 193.173 66.2721 193.173 67.7658C193.173 69.3652 191.929 70.3754 190.561 70.3754C189.095 70.3754 187.931 69.1807 187.931 67.7834ZM191.991 67.7922C191.991 66.9049 191.298 66.2457 190.561 66.2457C189.948 66.2457 189.113 66.764 189.113 67.7834C189.113 68.706 189.815 69.3035 190.561 69.3035C191.423 69.3035 191.991 68.5655 191.991 67.7922Z",
  fill: "black"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M194.336 65.3407H195.42V65.7538H195.438C195.536 65.5957 195.873 65.1738 196.726 65.1738C196.992 65.1738 197.686 65.2355 198.147 65.9383C198.663 65.2091 199.391 65.1738 199.738 65.1738C200.706 65.1738 201.186 65.6833 201.363 65.9295C201.559 66.1845 201.737 66.6499 201.737 67.3703V70.2173H200.555V67.5108C200.555 67.2299 200.555 66.2457 199.622 66.2457C199.293 66.2457 198.974 66.4214 198.805 66.7028C198.619 66.9925 198.627 67.476 198.627 67.7834V70.2173H197.446V67.5108C197.446 66.8432 197.188 66.2457 196.46 66.2457C195.518 66.2457 195.518 67.2651 195.518 67.7834V70.2173H194.336V65.3407Z",
  fill: "black"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M203.133 65.3407H204.217V65.7538H204.235C204.332 65.5957 204.67 65.1738 205.523 65.1738C205.789 65.1738 206.482 65.2355 206.944 65.9383C207.459 65.2091 208.188 65.1738 208.534 65.1738C209.503 65.1738 209.983 65.6833 210.16 65.9295C210.356 66.1845 210.533 66.6499 210.533 67.3703V70.2173H209.352V67.5108C209.352 67.2299 209.352 66.2457 208.419 66.2457C208.09 66.2457 207.77 66.4214 207.602 66.7028C207.415 66.9925 207.424 67.476 207.424 67.7834V70.2173H206.242V67.5108C206.242 66.8432 205.985 66.2457 205.256 66.2457C204.314 66.2457 204.314 67.2651 204.314 67.7834V70.2173H203.133V65.3407H203.133Z",
  fill: "black"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M216.318 65.3408V70.2174H215.235V69.7255H215.217C215.021 69.9888 214.702 70.3755 213.947 70.3755C213.049 70.3755 212.543 69.9364 212.294 69.6022C211.93 69.0839 211.93 68.293 211.93 67.8888V65.3408H213.111V67.8275C213.111 68.223 213.111 69.3036 214.142 69.3036C214.888 69.3036 215.137 68.6096 215.137 67.8364V65.3408H216.318V65.3408Z",
  fill: "black"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M217.838 65.3407H218.931V65.7626C219.126 65.5781 219.535 65.1738 220.281 65.1738C220.707 65.1738 221.356 65.3583 221.764 65.8502C222.218 66.3861 222.218 67.2035 222.218 67.5813V70.2173H221.036V67.8098C221.036 67.4056 221.036 66.2457 220.041 66.2457C219.828 66.2457 219.446 66.3514 219.232 66.6763C219.019 66.9749 219.019 67.4849 219.019 67.8975V70.2173H217.838V65.3407Z",
  fill: "black"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M223.604 63.7153H224.786V64.7872H223.604V63.7153ZM223.604 65.3407H224.786V70.2173H223.604V65.3407Z",
  fill: "black"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M231.04 68.6267C230.641 69.7166 229.726 70.3754 228.571 70.3754C227.309 70.3754 225.95 69.3736 225.95 67.757C225.95 66.2633 227.202 65.1738 228.562 65.1738C229.184 65.1738 230.534 65.4548 231.04 66.9573H229.708C229.566 66.7116 229.29 66.2457 228.562 66.2457C227.842 66.2457 227.132 66.7728 227.132 67.7746C227.132 68.6095 227.727 69.3035 228.615 69.3035C229.006 69.3035 229.397 69.119 229.708 68.6267H231.04Z",
  fill: "black"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M237.109 70.2173H236.025V69.6109C235.652 70.0504 234.924 70.3754 234.302 70.3754C233.031 70.3754 231.903 69.3736 231.903 67.7482C231.903 66.2545 233.005 65.1738 234.372 65.1738C235.376 65.1738 235.972 65.8855 236.007 65.9559H236.025V65.3407H237.109V70.2173ZM234.55 66.2457C233.582 66.2457 233.084 67.0718 233.084 67.801C233.084 68.6267 233.706 69.3035 234.55 69.3035C235.367 69.3035 235.989 68.6707 235.989 67.7658C235.989 66.7552 235.252 66.2457 234.55 66.2457Z",
  fill: "black"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M238.909 66.3773H238.073V65.3407H238.909V63.7153H240.091V65.3407H241.06V66.3773H240.091V70.2173H238.909V66.3773Z",
  fill: "black"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M241.87 63.7153H243.051V64.7872H241.87V63.7153ZM241.87 65.3407H243.051V70.2173H241.87V65.3407Z",
  fill: "black"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M244.215 67.7834C244.215 66.3073 245.432 65.1738 246.844 65.1738C248.239 65.1738 249.456 66.2721 249.456 67.7658C249.456 69.3652 248.213 70.3754 246.844 70.3754C245.379 70.3754 244.215 69.1807 244.215 67.7834ZM248.275 67.7922C248.275 66.9049 247.582 66.2457 246.844 66.2457C246.231 66.2457 245.397 66.764 245.397 67.7834C245.397 68.706 246.098 69.3035 246.844 69.3035C247.706 69.3035 248.275 68.5655 248.275 67.7922Z",
  fill: "black"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M250.62 65.3407H251.713V65.7626C251.908 65.5781 252.317 65.1738 253.063 65.1738C253.49 65.1738 254.138 65.3583 254.547 65.8502C255 66.3861 255 67.2035 255 67.5813V70.2173H253.818V67.8098C253.818 67.4056 253.818 66.2457 252.823 66.2457C252.61 66.2457 252.228 66.3514 252.015 66.6763C251.801 66.9749 251.801 67.4849 251.801 67.8975V70.2173H250.62V65.3407Z",
  fill: "black"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M187.184 83.2212H186.1V82.6236H186.083C185.861 82.975 185.345 83.3793 184.51 83.3793C183.257 83.3793 181.996 82.3603 181.996 80.7873C181.996 79.1443 183.329 78.1777 184.51 78.1777C185.23 78.1777 185.656 78.4151 186.003 78.7753V76.7192H187.184V83.2212ZM184.635 82.3074C185.523 82.3074 186.092 81.5165 186.092 80.7785C186.092 79.9788 185.47 79.2496 184.635 79.2496C183.755 79.2496 183.178 80.0581 183.178 80.7433C183.178 81.6482 183.862 82.3074 184.635 82.3074Z",
  fill: "black"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M189.559 81.1778C189.597 81.5841 190.11 82.3075 190.954 82.3075C191.478 82.3075 191.869 82.0878 192.092 81.6835H193.335C193.051 82.5625 192.109 83.3793 190.954 83.3793C189.488 83.3793 188.351 82.2194 188.351 80.7962C188.351 79.4165 189.426 78.1514 190.945 78.1514C192.509 78.1514 193.699 79.5689 193.452 81.1778H189.559ZM192.258 80.2377C192.071 79.5363 191.495 79.2232 190.954 79.2232C190.519 79.2232 189.883 79.4153 189.597 80.2377H192.258Z",
  fill: "black"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M196.57 79.6714C196.49 79.2848 196.223 79.2496 196.099 79.2496C195.806 79.2496 195.646 79.4693 195.646 79.6714C195.646 79.9524 195.85 80.014 196.481 80.2162C197.094 80.4007 197.858 80.6909 197.858 81.6746C197.858 82.7729 196.979 83.3793 196.134 83.3793C195.646 83.3793 195.042 83.2124 194.66 82.7381C194.357 82.3691 194.313 81.9825 194.287 81.6834H195.495C195.548 81.9032 195.655 82.3074 196.143 82.3074C196.525 82.3074 196.676 82.0172 196.676 81.8156C196.676 81.4549 196.41 81.3673 195.566 81.0859C195.006 80.9014 194.464 80.4887 194.464 79.6891C194.464 78.7401 195.326 78.1777 196.117 78.1777C196.854 78.1777 197.68 78.7048 197.725 79.6714H196.57V79.6714Z",
  fill: "black"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M198.854 76.7192H200.035V77.7911H198.854V76.7192ZM198.854 78.3446H200.035V83.2212H198.854V78.3446Z",
  fill: "black"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M206.45 78.3446V82.3251C206.45 85.1584 204.691 85.4624 203.758 85.4624C202.745 85.4624 201.706 84.9353 201.279 83.8459H202.63C203.091 84.3906 203.66 84.3906 203.847 84.3906C204.513 84.3906 205.357 83.9763 205.357 82.6148L205.339 82.5972C205.179 82.8169 204.726 83.3793 203.722 83.3793C202.523 83.3793 201.199 82.3691 201.199 80.7345C201.199 79.2055 202.461 78.1777 203.713 78.1777C204.726 78.1777 205.152 78.7489 205.286 78.9422H205.304V78.3446H206.45V78.3446ZM203.82 79.2496C203.109 79.2496 202.381 79.8207 202.381 80.7433C202.381 81.7363 203.136 82.3074 203.856 82.3074C204.566 82.3074 205.268 81.7099 205.268 80.7345C205.268 80.0405 204.7 79.2496 203.82 79.2496Z",
  fill: "black"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M207.969 78.3446H209.062V78.7665C209.257 78.582 209.666 78.1777 210.412 78.1777C210.839 78.1777 211.487 78.3622 211.896 78.8541C212.349 79.3901 212.349 80.2074 212.349 80.5852V83.2212H211.167V80.8137C211.167 80.4095 211.167 79.2496 210.172 79.2496C209.959 79.2496 209.577 79.3553 209.364 79.6803C209.15 79.9788 209.15 80.4888 209.15 80.9014V83.2212H207.969V78.3446Z",
  fill: "black"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M216.899 79.3815H216.223V78.3449H216.899C216.925 78.0199 216.978 77.4223 217.476 76.9828C217.751 76.7283 218.142 76.5874 218.507 76.5874H219.032V77.7385C218.382 77.7473 218.116 77.7561 218.08 78.3449H219.032V79.3815H218.08V83.2214H216.899V79.3815Z",
  fill: "black"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M224.924 83.2212H223.841V82.6148C223.467 83.0543 222.739 83.3793 222.117 83.3793C220.847 83.3793 219.718 82.3775 219.718 80.7521C219.718 79.2584 220.82 78.1777 222.188 78.1777C223.192 78.1777 223.787 78.8894 223.823 78.9598H223.841V78.3446H224.924V83.2212ZM222.366 79.2496C221.397 79.2496 220.9 80.0757 220.9 80.8049C220.9 81.6306 221.522 82.3074 222.366 82.3074C223.183 82.3074 223.805 81.6746 223.805 80.7697C223.805 79.7591 223.068 79.2496 222.366 79.2496Z",
  fill: "black"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M231.179 81.6306C230.779 82.7205 229.864 83.3793 228.709 83.3793C227.447 83.3793 226.088 82.3775 226.088 80.7609C226.088 79.2672 227.341 78.1777 228.7 78.1777C229.321 78.1777 230.672 78.4587 231.179 79.9612H229.846C229.703 79.7155 229.428 79.2496 228.7 79.2496C227.98 79.2496 227.269 79.7767 227.269 80.7785C227.269 81.6134 227.865 82.3074 228.753 82.3074C229.144 82.3074 229.535 82.1229 229.846 81.6306H231.179Z",
  fill: "black"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M232.593 79.3812H231.757V78.3446H232.593V76.7192H233.775V78.3446H234.744V79.3812H233.775V83.2212H232.593V79.3812Z",
  fill: "black"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M235.201 80.7873C235.201 79.3112 236.419 78.1777 237.831 78.1777C239.226 78.1777 240.443 79.276 240.443 80.7697C240.443 82.3691 239.199 83.3793 237.831 83.3793C236.365 83.3793 235.201 82.1846 235.201 80.7873ZM239.262 80.7961C239.262 79.9088 238.568 79.2496 237.831 79.2496C237.218 79.2496 236.383 79.7679 236.383 80.7873C236.383 81.7099 237.085 82.3074 237.831 82.3074C238.693 82.3074 239.262 81.5694 239.262 80.7961Z",
  fill: "black"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M241.607 78.3446H242.69V78.7753H242.708C242.93 78.4587 243.153 78.1777 243.765 78.1777H244.122V79.3112C243.047 79.3112 242.788 80.1897 242.788 80.4799V83.2212H241.607V78.3446Z",
  fill: "black"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M246.351 82.7637L244.548 78.3442H245.898L247.017 81.4721L248.208 78.3442H249.549L246.715 84.8462H245.445L246.351 82.7637Z",
  fill: "black"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M113.414 58.1768C107.911 58.1768 103.04 60.8934 100.091 65.0392V59.6408H97.1304V103.564H100.091V83.5243C103.04 87.67 107.911 90.3866 113.414 90.3866C122.392 90.3866 129.697 83.162 129.697 74.2818C129.697 65.4014 122.392 58.1768 113.414 58.1768ZM113.414 87.4585C106.067 87.4585 100.091 81.5475 100.091 74.2818C100.091 67.0161 106.067 61.1049 113.414 61.1049C120.76 61.1049 126.737 67.0161 126.737 74.2818C126.737 81.5475 120.76 87.4585 113.414 87.4585Z",
  fill: "black"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M166.299 45V65.0481C163.351 60.8973 158.477 58.1767 152.97 58.1767C143.991 58.1767 136.687 65.4014 136.687 74.2818C136.687 83.1619 143.991 90.3866 152.97 90.3866C158.477 90.3866 163.351 87.6661 166.299 83.5153V88.9225H169.26V45H166.299ZM152.97 87.4585C145.624 87.4585 139.647 81.5474 139.647 74.2818C139.647 67.0161 145.624 61.1048 152.97 61.1048C160.316 61.1048 166.293 67.0161 166.293 74.2818C166.293 81.5474 160.316 87.4585 152.97 87.4585Z",
  fill: "black"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M88.7934 59.6406H84.6063L71.8974 72.2102L59.1886 59.6406H55.0015L69.8038 74.2808L55 88.9224H59.1872L71.8974 76.3515L84.6075 88.9224H88.7947L73.991 74.2808L88.7934 59.6406Z",
  fill: "black"
});

var _ref32 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_b",
  x: -4,
  y: -4,
  width: 314,
  height: 148,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "BackgroundImage",
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "SourceAlpha",
  operator: "in",
  result: "effect1_backgroundBlur"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_backgroundBlur",
  result: "shape"
})));

function SvgLogoXpd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 306,
    height: 140,
    viewBox: "0 0 306 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoXpd);
export default __webpack_public_path__ + "static/media/logo_xpd.8926f953.svg";
export { ForwardRef as ReactComponent };